<template>
  <v-snackbar
    v-model="isActive"
    :timeout="timeout"
    :color="color"
    transition="slide-y-reverse-transition"
    :content-class="alertClass"
  >
    <div class="d-flex align-center">
      <v-icon color="white" class="mr-2">
        {{ icon }}
      </v-icon>
      <div class="white--text">{{ text }}</div>
    </div>

    <template v-slot:action="{ attrs }">
      <v-btn
        :fab="true"
        v-bind="attrs"
        @click="_resetHttpResponse"
        :color="color"
      >
        <v-icon>mdi-window-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "http-response",
  props: {
    text: {},
    color: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    timeout: {
      type: Number,
      default: 3000
    }
  },
  computed: {
    alertClass() {
      switch (this.color) {
        case "error":
          return "alert-error";
        case "warning":
          return "warning";
        case "success":
          return "alert-success";
        case "info":
          return "alert-info";
        default:
          return "";
      }
    },

    icon() {
      switch (this.color) {
        case "error":
          return "mdi-alert-circle";
        case "warning":
          return "mdi-alert";
        case "success":
          return "mdi-check-circle";
        case "info":
          return "mdi-information";
        default:
          return "mdi-information";
      }
    },

    iconColor() {
      return this.color === "success" ? "green" : this.color;
    }
  },
  methods: {
    ...mapActions("httpResponse", ["resetHttpResponse"]),

    _resetHttpResponse() {
      this.resetHttpResponse();
    }
  }
};
</script>

<style scoped>
::v-deep .warning {
  color: #856404 !important;
}

::v-deep .alert-error {
  color: #d32f2f !important;
}

::v-deep .alert-success {
  color: #2e7d32 !important;
}

::v-deep .alert-info {
  color: #1976d2 !important;
}

.v-btn--fab.v-size--default {
  height: 26px;
  width: 26px;
  box-shadow: none !important;
}

.v-btn--fab.v-size--default .v-icon {
  font-size: 15px;
}
</style>
